<template>
  <div class="section">
    <div class="container">
      <slot></slot>
      <h2 class="title">
        {{firstUp($tc($route.params.app))}}
      </h2>
      <ul>
        <li v-for="(link, index) in links" :key="index"><router-link :to="link.href">{{link.title}}</router-link></li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    firstUp (str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    }
  },
  computed: {
    permissions () {
      return this.$store.state.user.permissions
    },
    links () {
      const links = []
      for (const [model] of Object.entries(this.permissions[this.$route.params.app] || {})) {
        links.push({
          href: `/dashboard/${this.$route.params.app}/${model}`,
          title: this.firstUp(this.$tc(model))
        })
      }

      return links
    }
  }
}
</script>
